import { t } from "i18next";
import DBModal from "../../../../component/global/DBModal";
import DBInput from "../../../../component/global/DBInput";
import DBModalTitle from "../../../../component/global/DbModalTitle";
import DBFieldBlock from "../../../../component/global/DBFieldBlock";
import TreeSearchSelect from "./../../../../component/global/TreeSearchSelect/index";
import DBSelect from "../../../../component/global/DBSelect";
import DBButton from "../../../../component/global/DBButton";
import DBTextArea from "../../../../component/global/DBTextArea";
import { useContext, useEffect, useRef, useState } from "react";
import { useRequest } from "../../../../hooks/helperData/useRequest";
import {
    GET_AUTOMATION_GROUP_LIST,
    SETTING_FEATURES,
    SETTING_FEATURES_LIST,
    SETTING_FORMS,
    SETTING_FORMS_USER_GROUP,
    SETTING_ITEMS_TYPE,
    SETTING_ITEMS_TYPE_FAETURES,
    SETTING_ITEMS_TYPE_TREE,
} from "../../../../helperData/ApiAddress";
import DBSpinner from "../../../../component/global/DBSpinner";
import DBAddButton from "../../../../component/global/DBAddButton";
import { ToastContext } from "../../../../component/global/ToastContext";
import DBSwitch from "./../../../../component/global/DBSwitch/index";
import { featureTypeList } from "../../../../feedback/helperFunctions";
import { AutoComplete } from "antd";
import DBAutoComplete from "../../../../component/global/DBAutoComplete";
import { Trash } from "iconsax-react";
import {
    systemUserGroupRequestParams,
    systemUserGroupSelectOptions,
} from "../../../../helperData/systemUserGroups";
import IncentiveQuickSetup, {
    createQuickIncentive,
    defaultQuickSetup,
} from "../../../../features/incentives/IncentiveQuickSetup";

export default function FormModal({
    show,
    onHide,
    onSuccess,
    editMode,
    itemType,
}) {
    const [form, setForm] = useState({
        name: "",
        user_group: null,
        active: true,
        features: [],
    });

    const toast = useContext(ToastContext);
    const [quickSetup, setQuickSetup] = useState(() =>
        defaultQuickSetup("form")
    );
    const [partialTarget, setPartialTarget] = useState(null);
    const [quickSaving, setQuickSaving] = useState(false);

    const [formErr, setFormErr] = useState({
        name: "",
        features: [],
    });
    const [options, setOptions] = useState([]);
    const [userGroups, setUserGroups] = useState([]);

    const [getFormFeatures, getFormFeaturesLoading, getFormFeaturesCancel] =
        useRequest(SETTING_FEATURES_LIST, "GET");

    const [getFormUserGroup, getFormUserGroupLoader] = useRequest(
        SETTING_FORMS_USER_GROUP,
        "GET"
    );
    const [sendForm, sendFormLoader] = useRequest(
        SETTING_FORMS + (editMode ? `${editMode}/` : ""),
        editMode ? "PUT" : "POST"
    );

    const [getForm, getFormLoader] = useRequest(
        SETTING_FORMS + editMode + "/",
        "GET"
    );

    useEffect(() => {
        if (show) {
            setQuickSetup(defaultQuickSetup("form"));
            setPartialTarget(null);
            getFormFeaturesHandle();
            getFormUserGroupHandle();
            if (editMode) {
                getForm().then((r) => {
                    setForm({
                        name: r.name,
                        user_group: r.user_group,
                        active: r.active,
                        features: r.features.map((feature) => ({
                            feature: {
                                label: feature.name,
                                value: feature.name.toLowerCase(),
                                id: feature.feature,
                            },
                            mandatory: feature.mandatory,
                            language: feature.language,
                        })),
                    });
                });
            } else {
                setForm({
                    name: "",
                    user_group: null,
                    active: true,
                    features: [],
                });
            }

            setFormErr({
                name: "",
                features: [],
            });
        }
    }, [show]);

    const getFormFeaturesHandle = () => {
        getFormFeaturesCancel?.();
        getFormFeatures({ feature_level: 2 }).then((r) => {
            setOptions(
                r.map((item) => ({
                    label: item.name,
                    value: item.name.toLowerCase(),
                    id: item.id,
                }))
            );
        });
    };

    const getFormUserGroupHandle = () => {
        getFormUserGroup(systemUserGroupRequestParams()).then((r) => {
            setUserGroups(systemUserGroupSelectOptions(r));
        });
    };

    const addEditForm = () => {
        let formErrTemp = { name: "", user_group: null, features: [] };

        if (form.name.trim() === "") {
            formErrTemp = { ...formErrTemp, name: t("form.name.required") };
        }
        for (let featureItem of form.features) {
            if (
                !featureItem.feature.id &&
                featureItem.feature?.name.length <= 2
            ) {
                formErrTemp = {
                    ...formErrTemp,
                    features: [
                        ...formErrTemp.features,
                        t("form.feature.length.err"),
                    ],
                };
            }
        }

        setFormErr(formErrTemp);

        if (formErrTemp.name || formErrTemp.features.length) return false;
        sendForm({
            ...form,
            user_group: form.user_group || null,
            item_type: itemType,
            features: form.features.map((r) => ({
                ...r,
                feature: r.feature.id ? r.feature.id : r.feature,
            })),
        })
            .then(async (r) => {
                const target = {
                    id: r?.id || editMode,
                    name: r?.name || form.name,
                    type: "form",
                };
                if (quickSetup.enabled) {
                    setQuickSaving(true);
                    try {
                        await createQuickIncentive(quickSetup, target);
                    } catch {
                        setPartialTarget(target);
                        toast(t("incentives.quick.partialTitle"), "danger");
                        return;
                    } finally {
                        setQuickSaving(false);
                    }
                }
                onHide?.();
                onSuccess?.(r);
                toast(t("form.save.success"), "success");
            })
            .catch((e) => {
                if (e.response?.status === 400) {
                    if (
                        e.response?.data.message ===
                        "There is another active for this user group"
                    ) {
                        toast(t("form.user.group.error"), "danger");
                    } else if (
                        e.response?.data.message ===
                        "feature with this name and company and type already exists."
                    ) {
                        toast(t("form.feature.duplicate.error"), "danger");
                    } else {
                        toast(t("form.save.error"), "danger");
                    }
                } else {
                    toast(t("form.save.error"), "danger");
                }
            });
    };

    const retryQuickSetup = () => {
        setQuickSaving(true);
        createQuickIncentive(quickSetup, partialTarget)
            .then(() => {
                setPartialTarget(null);
                onHide?.();
                onSuccess?.(partialTarget);
                toast(t("form.save.success"), "success");
            })
            .catch(() => toast(t("incentives.error.publish"), "danger"))
            .finally(() => setQuickSaving(false));
    };

    return (
        <DBModal
            permanent
            show={show}
            minWidth={560}
            onHide={onHide}
            className="form-modal"
        >
            <DBModal.Header closeBtn={onHide} title={t("create.form")} />

            <DBModal.Content>
                {getFormFeaturesLoading ||
                getFormUserGroupLoader ||
                getFormLoader ? (
                    <DBSpinner tip={t("loading")} />
                ) : (
                    <>
                        <DBModalTitle>
                            {t("item.type.main.fields")}
                        </DBModalTitle>
                        <div className="grid">
                            <DBFieldBlock
                                title={t("form.name")}
                                required
                                error={formErr.name}
                            >
                                <DBInput
                                    onClick={() =>
                                        setFormErr({ ...formErr, name: "" })
                                    }
                                    status={formErr.name && "error"}
                                    type="text"
                                    size="large"
                                    value={form.name}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            name: e.target.value,
                                        })
                                    }
                                />
                            </DBFieldBlock>
                            <DBFieldBlock
                                title={t("form.user.group")}
                                error={formErr.user_group}
                            >
                                <DBSelect
                                    allowClear
                                    onClick={() =>
                                        setFormErr({
                                            ...formErr,
                                            user_group: "",
                                        })
                                    }
                                    status={formErr.user_group && "error"}
                                    placeholder={t("form.select")}
                                    value={form.user_group}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            user_group: e ?? null,
                                        })
                                    }
                                    options={userGroups}
                                    size="large"
                                />
                            </DBFieldBlock>
                            <DBFieldBlock title={t("form.active")} required>
                                <div className="features-switch-container">
                                    <DBSwitch
                                        checked={form.active}
                                        onChange={(e) =>
                                            setForm({ ...form, active: e })
                                        }
                                    />
                                </div>
                            </DBFieldBlock>
                        </div>
                        <DBModalTitle>{t("form.features.label")}</DBModalTitle>
                        {form.features.length > 0 && (
                            <div className="form-fields-grid">
                                {form.features.map((feature, index) => {
                                    return (
                                        <>
                                            <DBFieldBlock
                                                title={t("form.feature.name")}
                                                required
                                                error={formErr.features[index]}
                                            >
                                                <DBAutoComplete
                                                    status={
                                                        formErr.features[
                                                            index
                                                        ] && "error"
                                                    }
                                                    onClick={() => {
                                                        const temp = [
                                                            ...formErr.features,
                                                        ];
                                                        temp[index] = undefined;
                                                        setFormErr({
                                                            ...formErr,
                                                            features: temp,
                                                        });
                                                    }}
                                                    onChange={(
                                                        caption,
                                                        option
                                                    ) => {
                                                        const temp = [
                                                            ...form.features,
                                                        ];

                                                        if (option.value) {
                                                            temp[
                                                                index
                                                            ].feature = option;
                                                        } else {
                                                            temp[index] = {
                                                                feature: {
                                                                    name: caption,
                                                                    value: caption,
                                                                    language:
                                                                        "fa",
                                                                    feature_type: 1,
                                                                    feature_level: 2,
                                                                },
                                                                mandatory: false,
                                                            };
                                                        }
                                                        console.log(temp);
                                                        setForm({
                                                            ...form,
                                                            features: temp,
                                                        });
                                                    }}
                                                    value={feature.feature}
                                                    options={options}
                                                />
                                            </DBFieldBlock>
                                            <DBFieldBlock
                                                title={t(
                                                    "form.feature.language"
                                                )}
                                                required
                                            >
                                                <DBSelect
                                                    disabled={
                                                        feature.feature.id
                                                    }
                                                    value={
                                                        feature.feature.language
                                                    }
                                                    onChange={(e) => {
                                                        const temp = [
                                                            ...form.features,
                                                        ];
                                                        temp[
                                                            index
                                                        ].feature.language = e;
                                                        setForm({
                                                            ...form,
                                                            features: temp,
                                                        });
                                                    }}
                                                    options={[
                                                        {
                                                            value: "fa",
                                                            label: t(
                                                                "item.type.language.fa"
                                                            ),
                                                        },
                                                        {
                                                            value: "en",
                                                            label: t(
                                                                "item.type.language.en"
                                                            ),
                                                        },
                                                        {
                                                            value: "ar",
                                                            label: t(
                                                                "item.type.language.ar"
                                                            ),
                                                        },
                                                    ]}
                                                    size="large"
                                                />
                                            </DBFieldBlock>
                                            <DBFieldBlock
                                                title={t(
                                                    "form.feature.required"
                                                )}
                                                required
                                            >
                                                <DBSelect
                                                    value={feature.mandatory}
                                                    onChange={(e) => {
                                                        const temp = [
                                                            ...form.features,
                                                        ];
                                                        temp[index].mandatory =
                                                            e;
                                                        setForm({
                                                            ...form,
                                                            features: temp,
                                                        });
                                                    }}
                                                    options={[
                                                        {
                                                            value: false,
                                                            label: t(
                                                                "form.feature.mandatory.false"
                                                            ),
                                                        },
                                                        {
                                                            value: true,
                                                            label: t(
                                                                "form.feature.mandatory.true"
                                                            ),
                                                        },
                                                    ]}
                                                    size="large"
                                                />
                                            </DBFieldBlock>
                                            <div
                                                style={{
                                                    textAlign: "center",
                                                    cursor: "pointer",
                                                    marginTop: 30,
                                                }}
                                            >
                                                <Trash
                                                    size={20}
                                                    color="red"
                                                    onClick={() =>
                                                        setForm({
                                                            ...form,
                                                            features: [
                                                                ...form.features.filter(
                                                                    (_, ind) =>
                                                                        ind !==
                                                                        index
                                                                ),
                                                            ],
                                                        })
                                                    }
                                                />
                                            </div>
                                        </>
                                    );
                                })}
                            </div>
                        )}
                        <div className="fullwidth-button">
                            <DBButton
                                caption={t("add.form.feature.btn")}
                                className="fullwidth-button"
                                outlined
                                onClick={() => {
                                    setForm({
                                        ...form,
                                        features: [
                                            ...form.features,
                                            {
                                                feature: {
                                                    name: "",
                                                    language: "fa",
                                                    feature_type: 1,
                                                    feature_level: 2,
                                                },
                                                mandatory: false,
                                            },
                                        ],
                                    });
                                }}
                            />
                        </div>
                        <IncentiveQuickSetup
                            value={quickSetup}
                            onChange={setQuickSetup}
                            targetType="form"
                            partialFailure={Boolean(partialTarget)}
                            retrying={quickSaving}
                            onRetry={retryQuickSetup}
                        />
                    </>
                )}
            </DBModal.Content>
            <DBModal.Footer>
                <DBButton
                    caption={t("save")}
                    onClick={addEditForm}
                    loading={sendFormLoader || quickSaving}
                />
                <DBButton
                    caption={t("cancel")}
                    type="secondary"
                    onClick={onHide}
                />
            </DBModal.Footer>
        </DBModal>
    );
}
